export const arePlanIdOrdersEqual = (left: string[], right: string[]): boolean =>
  left.length === right.length && left.every((id, index) => id === right[index]);

export const orderPlanIdsByDisplayOrder = (
  planIds: string[],
  displayOrder: string[] | undefined,
): string[] => {
  if (!displayOrder?.length) {
    return planIds;
  }

  const planIdSet = new Set(planIds);
  const ordered = displayOrder.filter(id => planIdSet.has(id));
  const orderedSet = new Set(ordered);
  const remaining = planIds.filter(id => !orderedSet.has(id));

  return [...ordered, ...remaining];
};

export const resolveOrderedPlanIds = (
  planIds: string[],
  savedDisplayOrder: string[] | undefined,
  localOrder: string[],
  hasUnsavedReorder: boolean,
): string[] =>
  orderPlanIdsByDisplayOrder(planIds, hasUnsavedReorder ? localOrder : savedDisplayOrder);

export const mapPlansByOrderedIds = <T extends { planId: string }>(
  plans: T[],
  orderedPlanIds: string[],
): T[] => {
  const plansById = new Map<string, T>(plans.map(plan => [plan.planId, plan]));

  return orderedPlanIds
    .map(planId => plansById.get(planId))
    .filter((plan): plan is T => plan !== undefined);
};
